// services/paymentService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const paymentService = {

    createCheckoutSession: async (orderData, scontoSpedizione = 0, scontoTipo = null) => {
        console.log('💰 Creazione sessione Stripe per ordine:', orderData.numero_ordine);
        
        try {
            const response = await axios.post(`${API_URL}/create-checkout-session`, {
                orderId: orderData.numero_ordine,
                amount: orderData.importo_totale,
                currency: 'eur',
                orderData: orderData,
                scontoSpedizione: scontoSpedizione,
                scontoTipo: scontoTipo
            }, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            console.log('✅ Sessione Stripe creata:', response.data);
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Errore nella creazione della sessione';
            throw new Error(errorMessage);
        }
    },
    
    // PayPal
    createPayPalOrder: async (amount, currency, orderId) => {
        try {
            const response = await axios.post(`${API_URL}/create-paypal-order`, {
                amount,
                currency,
                orderId
            }, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'Errore nella creazione ordine PayPal';
            throw new Error(errorMessage);
        }
    },
    
    capturePayPalOrder: async (orderID, orderData) => {
        try {
            const response = await axios.post(`${API_URL}/capture-paypal-order`, {
                orderID,
                orderData
            }, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'Errore nel completamento pagamento PayPal';
            throw new Error(errorMessage);
        }
    },
    
    // Bonifico
    confirmBonifico: async (orderId) => {
        try {
            const response = await axios.post(`${API_URL}/confirm-bonifico`, {
                orderId
            }, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            
            return response.data;
        } catch (error) {
            const errorMessage = error.response?.data?.error || 'Errore nella conferma del bonifico';
            throw new Error(errorMessage);
        }
    }
};